/** Only explicit source identifiers create associations; absent registration stays empty. */
import type { RmReq, RmFeat, RmCase } from '../mock/reqmgmt'
import type { SolSolution } from '../mock/solutions'

export interface ApplicationLinks {
  unavailable?: string[]
  requirements: { code: string; name: string; own: string; st: string }[]
  solutions: { id: string; name: string; st: string; adj: string; rv: string }[]
  features: { code: string; name: string; blk: string; rv: string }[]
  tests: { code: string; name: string; target: string; rv: string }[]
  interfaces: { code: string; name: string; kind: string; to: string }[]
  operations: { code: string; name: string; kind: string }[]
  roles: { code: string; name: string; st: string }[]
}

export function emptyApplicationLinks(): ApplicationLinks {
  return { requirements: [], solutions: [], features: [], tests: [], interfaces: [], operations: [], roles: [] }
}

export function applicationLinks(code: string, input: {
  reqs?: RmReq[]; feats?: RmFeat[]; cases?: RmCase[]; sols?: SolSolution[]
  services: { code: string; appCode: string }[]
  interfaces: { code: string; name: string; svcRef: string; style: string }[]
  interfaceLabels?: Record<string,string>
}): ApplicationLinks {
  const reqs = (input.reqs || []).filter(r => r.appCode === code || r.archRefs?.some(a => a.dim === 'AA' && a.code === code))
  const reqIds = new Set(reqs.map(r => r.id))
  const services = new Set(input.services.filter(s => s.appCode === code).map(s => s.code))
  return {
    ...emptyApplicationLinks(),
    unavailable: (['reqs','feats','cases','sols'] as const).filter(key => input[key] === undefined),
    requirements: reqs.map(r => ({ code: r.id, name: r.title, own: r.appCode === code ? '主责应用' : '架构关联', st: r.review })),
    solutions: (input.sols || []).filter(s => s.apps.some(a => a.code === code)).map(s => ({
      id: s.id, name: s.name, st: s.st, adj: s.apps.find(a => a.code === code)?.role || '已登记', rv: s.review || '未评审'
    })),
    features: (input.feats || []).filter(f => reqIds.has(f.reqId)).map(f => ({ code: f.id, name: f.name, blk: f.reqId, rv: f.st })),
    tests: (input.cases || []).filter(t => reqIds.has(t.reqId)).map(t => ({ code: t.id, name: t.scene, target: t.reqId, rv: t.st })),
    interfaces: input.interfaces.filter(i => services.has(i.svcRef)).map(i => ({
      code: i.code, name: i.name, kind: input.interfaceLabels?.[i.style] || i.style, to: i.svcRef
    }))
  }
}
